import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import type { PlaceId } from '~/places/places.types';
import {
  frontendStatePlacesCollapseSearch, frontendStatePlacesExpandSearch, frontendStatePlacesSetHoveredSearch, frontendStatePlacesStopHoveredSearch,
} from '~/store/frontendState/places/places.actionCreators';
import { usePlacesSearchExpandedSearchesSelector } from '~/store/frontendState/places/places.selectors';
import type { PlacesSearchId } from '~/store/mapSettings/places/mapSettingsPlaces.state';
import type { PlaceSearchListingItem } from './placesTool.container';
import { PlacesToolListingComponent } from './placesToolListing.component';

export const PlacesToolListingContainer = ({
  searches,
}: {
  searches: ReadonlyArray<PlaceSearchListingItem>;
}) => {
  const dispatch = useDispatch();
  const expandedSearches = usePlacesSearchExpandedSearchesSelector();

  const onSearchHovered = useCallback((searchId: PlacesSearchId) => {
    dispatch(frontendStatePlacesSetHoveredSearch({ searchId }));
  }, [dispatch]);

  const onSearchHoverStopped = useCallback(() => {
    dispatch(frontendStatePlacesStopHoveredSearch());
  }, [dispatch]);

  const toggleSearch = useCallback((searchId: PlaceId) => {
    if (expandedSearches.has(searchId)) {
      dispatch(frontendStatePlacesCollapseSearch(searchId));
    }
    else {
      dispatch(frontendStatePlacesExpandSearch(searchId));
    }
  }, [dispatch, expandedSearches]);

  return (
    <PlacesToolListingComponent
      expandedSearches={expandedSearches}
      searches={searches}
      onToggleSearch={toggleSearch}
      onSearchHovered={onSearchHovered}
      onSearchHoverStopped={onSearchHoverStopped}
    />
  );
};
